export default __webpack_public_path__ + "static/media/url-shorteningImg_2.75ec7f4a.webp";